import * as React from "react"

export default function LanguageOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.667A6.667 6.667 0 108 1.334a6.667 6.667 0 000 13.333zm1.469-1.538a5.339 5.339 0 003.823-4.462H10.98c-.128 2.018-.823 3.484-1.51 4.462zm-2.937 0a5.339 5.339 0 01-3.824-4.462h2.313c.128 2.018.824 3.484 1.51 4.462zm-.175-4.462c.123 1.674.693 2.868 1.24 3.658.137.198.274.373.403.523.13-.15.266-.325.404-.524.546-.789 1.116-1.983 1.239-3.657H6.357zm3.286-1.333H6.357c.123-1.674.693-2.869 1.24-3.658.137-.2.274-.373.403-.523.13.15.266.324.404.523.546.789 1.116 1.984 1.239 3.657zm1.336 0h2.313A5.339 5.339 0 009.47 2.872c.687.977 1.382 2.443 1.51 4.462zM6.532 2.872c-.687.977-1.383 2.443-1.511 4.462H2.708a5.339 5.339 0 013.824-4.462z"
        fill={props.fill}
      />
    </svg>
  )
}